import { RequestStatus } from '@/enums/request-status.enum';
import { ApiResponse } from '@/interfaces/apiresponse.interface';
import { CreateAccessRequest } from '@/interfaces/createAccessRequest.interface';
import { API_BASE_URI } from '@/shared/constants';
import Helpers from '@/shared/helpers';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EngagementAccessService {

  constructor(private http: HttpClient) { }

  async approvedAndPendingUsers(engagementId: string){
    const url = API_BASE_URI + `/api/engagementAccess/${engagementId}/approvedAndPendingUsers`;

    return await firstValueFrom(this.http.get<HttpResponse<ApiResponse>>(url, <Object>Helpers.getDefaultHttpOptions()));
  }

  async usersWithoutAccess(engagementId: string){
    const url = API_BASE_URI + `/api/engagementAccess/${engagementId}/usersWithoutAccess`;

    return await firstValueFrom(this.http.get<HttpResponse<ApiResponse>>(url, <Object>Helpers.getDefaultHttpOptions()));
  }

  async users(engagementId: string){
    const url = API_BASE_URI + `/api/engagementAccess/${engagementId}/users`;

    return await firstValueFrom(this.http.get<HttpResponse<ApiResponse>>(url, <Object>Helpers.getDefaultHttpOptions()));
  }

  async managedEngagements(){
    const url = API_BASE_URI + `/api/engagementAccess/managedEngagements`;

    return await firstValueFrom(this.http.get<HttpResponse<ApiResponse>>(url, <Object>Helpers.getDefaultHttpOptions()));
  }

  async engagements(){
    const url = API_BASE_URI + `/api/engagementAccess/Engagements`;

    return await firstValueFrom(this.http.get<HttpResponse<ApiResponse>>(url, <Object>Helpers.getDefaultHttpOptions()));
  }

  async getAllRequests(){
    const url = API_BASE_URI + `/api/engagementAccess/GetAllRequests`;

    return await firstValueFrom(this.http.get<HttpResponse<ApiResponse>>(url, <Object>Helpers.getDefaultHttpOptions()));
  }

  async getRequest(requestId: string){
    const url = API_BASE_URI + `/api/engagementAccess/request/${requestId}`;

    return await firstValueFrom(this.http.get<HttpResponse<ApiResponse>>(url, <Object>Helpers.getDefaultHttpOptions()));
  }

  async approveRequest(requestId: string, accept: boolean){
    const url = API_BASE_URI + `/api/engagementAccess/request/${requestId}/approve`;

    return await firstValueFrom(this.http.post<HttpResponse<ApiResponse>>(url, {
      requestStatus: accept ? RequestStatus.Approved : RequestStatus.Rejected
    }, <Object>Helpers.getDefaultHttpOptions()));  
  }

  async createRequests(accessRequests: CreateAccessRequest[]){
    const url = API_BASE_URI + `/api/engagementAccess/CreateRequest`;
    
    return await firstValueFrom(this.http.post<HttpResponse<ApiResponse>>(url, accessRequests, <Object>Helpers.getDefaultHttpOptions()));  
  
  }

  async revokeAccess(engagementId: string, userId: string){
    const url = API_BASE_URI + `/api/engagementAccess/${engagementId}/${userId}/RevokeAccess`;

    const options = <{
      headers?: HttpHeaders | {
          [header: string]: string | string[];
      };
      body?: any | null;
    }>Helpers.getDefaultHttpOptions();

    return await firstValueFrom(this.http.delete<HttpResponse<ApiResponse>>(url, options));
  }
}
